export const threatCard = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

export const threatCardHeader = {
  background: "transparent",
  borderBottom: "1px solid var(--vz-border-color)",
  padding: "14px 18px",
};

export const threatCardBody = {
  padding: "16px 18px",
};

export const threatIconStyle = (color = "var(--vz-primary)") => ({
  color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
});

export const threatIconChip = (color = "var(--vz-primary)") => ({
  width: 32,
  height: 32,
  borderRadius: 8,
  border: `1px solid ${color.replace("var(--vz-primary)", "rgba(var(--vz-primary-rgb), 0.35)")}`,
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  color,
});

export const threatIconChipWithBorder = (color = "var(--vz-primary)") => ({
  width: 32,
  height: 32,
  borderRadius: 8,
  border: `1px solid ${color.replace("var(--vz-primary)", "rgba(var(--vz-primary-rgb), 0.20)")}`,
  background: color.startsWith("#") ? hexToRgba(color, 0.08) : "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  color,
});

function hexToRgba(hex, alpha) {
  const value = hex.replace("#", "");
  const full = value.length === 3
    ? value.split("").map(ch => ch + ch).join("")
    : value;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
